let analyticsItem;

export const registerAnalyticsViewItemEvent = (product, index) => {
  const googleAnalyticsObject = {
    event: 'view_item',
    ecommerce: {
      currency: `EUR`,
      items: [generateAnalyticsItem(product, index)],
    },
  };
  window?.dataLayer?.push(googleAnalyticsObject);
  return googleAnalyticsObject.ecommerce.items;
};

export const registerAnalyticsViewListEvent = (productsFromApi) => {
  const googleAnalyticsObject = {
    event: 'view_item_list',
    ecommerce: {
      item_list_name: `Overview - TriplePlay`,
      comparison_id: productsFromApi[0].commonTechnical[0].transactionReference,
      items: productsFromApi.map((elem, index) => {
        return generateAnalyticsItem(elem, index);
      }),
    },
  };
  window?.dataLayer?.push(googleAnalyticsObject);
  return googleAnalyticsObject.ecommerce.items;
};

export const registerAnalyticsAddToCartEvent = (product) => {
  analyticsItem = product.analyticsData;
  const googleAnalyticsObject = {
    event: 'add_to_cart',
    ecommerce: {
      currency: 'EUR',
      coupon: '',
      items: [analyticsItem],
    },
  };
  window?.dataLayer?.push(googleAnalyticsObject);
};

export const registerTopThreeClickEvent = (product) => {
  registerAnalyticsAddToCartEvent(product);
  analyticsItem = product.analyticsData;
  const googleAnalyticsObject = {
    event: 'TriplePlay_top3_click',
    event_action: 'Top 3 product click',
    event_category: 'Funnel - TriplePlay',
    event_label: product.tags,
    comparison_id: product.comparisonId,
  };

  window?.dataLayer?.push(googleAnalyticsObject);
};

const generateAnalyticsItem = (data, index) => {
  const affiliation =
    data.affiliateUrl === ''
      ? 'Direct'
      : data.affiliateUrl.includes('awin1')
        ? 'Awin'
        : 'Daisycon';

  const discount = parseFloat(
    (data.priceInfo.initial - data.priceInfo.total).toFixed(2),
  );

  return {
    item_id: data.id,
    item_name: data.subscriptionName,
    item_list_name: 'Overview - TriplePlay',
    affiliation,
    currency: 'EUR',
    discount,
    index: index + 1,
    item_brand: data.provider.name,
    item_category: 'TriplePlay',
    itemCategory2: data.category,
    itemCategory3: `${parseInt(data.durationInMonths)} maanden`,
    itemCategory4: data.network,
    itemCategory5: data.downloadSpeedInMb,
    price: data.priceInfo.initial,
  };
};
